import React, { useEffect, useState } from "react";
import {
  editItemAPI,
  getItemToEditAPI,
  getTiposBeneficioItemAPI,
  getUbicacionesBeneficioItemAPI
} from "../../../../consumers/backendApisUrls";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { usePropsInputs } from "../../../../hooks/useProps/usePropsInput";
import BaseItem from "./BaseItem";
import {useGetOptionsSelect} from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {initialAllOptionPromises} from "../../../../helper/utils";

const EditarItem = ({ toggleModal, refreshPage, IdBeneficioItem }) => {
  const SECTION_NAME = "EditarItem";
  const KEYS = {
    IdBeneficioItem: "IdBeneficioItem",
    Descripcion: "Descripcion",
    Monto: "Monto",
    ImagenBeneficio: "File",
    Detalle: "Detalle",
    IdTipoBeneficioItem: "IdTipoBeneficioItem",
    IdUbicacionBeneficioItem: "IdUbicacionBeneficioItem"
  };

  const KEYS_DROPDOWN = ["IdTipoBeneficioItem","IdUbicacionBeneficioItem"];

  const [formValues, setFormValues] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [submitForm] = useSubmitForm();
  const [executeGet] = useManageGetRequest();

  const [allDropdowns, setAllDropdowns] = useState([]);
  const [getOption] = useGetOptionsSelect();
  const [selectProps] = usePropsSelect(
      allDropdowns,
      formValues,
      setFormValues,
      SECTION_NAME
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const api = editItemAPI();
    const payload = getPayload();
    try {
      await submitForm(
        Object.values(KEYS),
        api,
        payload,
        SECTION_NAME,
        successSubmit
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getPayload = () => {
    const payload = {
      IdBeneficioItem: formValues[KEYS.IdBeneficioItem],
      Descripcion: formValues[KEYS.Descripcion],
      Monto: formValues[KEYS.Monto],
      File: formValues[KEYS.ImagenBeneficio],
      Detalle: formValues[KEYS.Detalle],
      IdTipoBeneficioItem: formValues[KEYS.IdTipoBeneficioItem],
      IdUbicacionBeneficioItem: formValues[KEYS.IdUbicacionBeneficioItem],
    };
    return payload;
  };

  const successSubmit = async () => {
    toggleModal();
    await refreshPage();
  };

  const init = async () => {
    const api = getItemToEditAPI(IdBeneficioItem);
    await executeGet(api, successInitCallback);
  };

  const successInitCallback = ({ data }) => {
    setFormValues(data);
  };

  useEffect(() => {
    init();
    getDropdowns();
  }, []);

  const getDropdowns = async () => {
    const dropdownsPromises = () => [
      getOption(getTiposBeneficioItemAPI()),
      getOption(getUbicacionesBeneficioItemAPI()),
    ]
    await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, handleDropdowns);
  }

  const handleDropdowns = (data) => {
    const updatedData = [...data];
    setAllDropdowns(updatedData);
  }

  return (
    <BaseItem
      toggleModal={toggleModal}
      title="Editar Ítem"
      puedeEditar={true}
      sectionName={SECTION_NAME}
      KEYS={KEYS}
      formValues={formValues}
      setFormValues={setFormValues}
      commonProps={commonProps}
      isUploading={isUploading}
      setIsUploading={setIsUploading}
      isSubmitting={isSubmitting}
      handleSubmit={handleSubmit}
      selectProps={selectProps}
    />
  );
};

export default EditarItem;
